import { Injectable, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RetrieveTokenService implements AfterViewInit{
  private token = new BehaviorSubject<string>('');
  private loggedInConsultantID = new BehaviorSubject<string>('');
  private tokenExpiry: number = 0;

  constructor(private http: HttpClient) {

  }

  ngAfterViewInit(): void {
    //ToDo: Update token expiry handling
    // this.getToken.subscribe( async res => {
    //   if(res != ''){
    //     await new Promise(f => setTimeout(f, this.tokenExpiry));
    //     this.setToken();
    //   }
    // });
  }

  public set setToken(token:string){
    this.token.next(token);
    //ToDo: Get token expiry from db call aswell
    //this.tokenExpiry = (data.expires_in - 60) * 1000;
  }

  public get getToken(): Observable<string> {
    return this.token.asObservable();
  }

  public get getTokenVal(): string{

    return this.token.getValue();
  }

  public set setloggedInConsultantID(id:string){
    this.loggedInConsultantID.next(id);
  }

  public get getloggedInConsultantID(){
    return this.loggedInConsultantID.getValue();
  }
}
